import React from 'react';

import LabelsChart from '../../containers/labels/LabelsChart';

const LabelsWrapper = ({
  originalZoneId,
  zoneId,
  labels,
  options,
  result,
  unit,
  fromDashboard,
}) => (
  <div className="st-labels-chart">
    <LabelsChart
      zoneId={originalZoneId}
      userZoneId={zoneId}
      labels={labels}
      from={options.from}
      to={options.to}
      show={result.some(({ result: resultParam }) => !!resultParam.rows.length)}
      unitId={unit?.id}
      fromDashboard={fromDashboard}
    />
  </div>
);

export default LabelsWrapper;
